import React, { PureComponent } from 'react';
import {
  Modal, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Informations from '../../AssetDetails/components/Informations';
import Administratif from '../../AssetDetails/components/Administratif';
import Contacts from '../../AssetDetails/components/Contacts';
import Directives from '../../AssetDetails/components/Directives';
import Patrimoine from '../../AssetDetails/components/Patrimoine';

class AssetModalFull extends PureComponent {
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    isModal: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    setDocument: PropTypes.func.isRequired,
    openAsset: PropTypes.func.isRequired,
    list_assets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    contacts_pro: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  };

  constructor() {
    super();

    this.state = {
      activeTab: '1',
    };
  }

  toggleTab = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const {
      toggle, isModal, data, setDocument, list_assets, openAsset, contacts_pro,
    } = this.props;
    // console.log('list assets: ', list_assets);
    const { activeTab } = this.state;
    const {
      category, documents, _id, instructions,
    } = data;
    return (
      <Modal
        isOpen={isModal}
        toggle={toggle}
        modalClassName="ltr-support"
        className="modal-dialog--lightOfficial modal-dialog--header theme-light modal-bigger"
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
          <h4 className="semiBold text-modal modal__title">
            {data.title}
          </h4>
        </div>
        <ModalBody className="p-0">
          <div className="profile__card tabs tabs--bordered-bottom">
            <div className="tabs__wrap">
              <Nav tabs>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => this.toggleTab('1')}>
                    Informations
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => this.toggleTab('2')}>
                    {category === 'company' ? 'Vie d\'entreprise' : 'Annexes'}
                  </NavLink>
                </NavItem>
                {
                  category === 'company' && (
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => this.toggleTab('3')}>
                        Patrimoine
                      </NavLink>
                    </NavItem>
                  )
                }
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === '4' })} onClick={() => this.toggleTab('4')}>
                    Annuaire
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: activeTab === '5' })} onClick={() => this.toggleTab('5')}>
                    Directives
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Informations
                    data={data}
                    documents={documents}
                    setDocument={setDocument}
                    isViewOnly
                  />
                </TabPane>
                <TabPane tabId="2">
                  <Administratif
                    data={{ ...data, list_assets }}
                    setDocument={setDocument}
                    isViewOnly
                  />
                </TabPane>
                {
                  category === 'company' && (
                    <TabPane tabId="3">
                      <Patrimoine
                        list_assets={list_assets}
                        assetId={_id}
                        assets={[]}
                        openAsset={openAsset}
                        isViewOnly
                      />
                    </TabPane>
                  )
                }
                <TabPane tabId="4">
                  <Contacts
                    data={data}
                    assetId={_id}
                    contacts_pro={contacts_pro}
                    isViewOnly
                  />
                </TabPane>
                <TabPane tabId="5">
                  <Directives
                    data={data}
                    instructions={instructions}
                    isViewOnly
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default AssetModalFull;
